import a1 from '../assets/a1.png';
import a2 from '../assets/a2.png';
import a3 from '../assets/a3.png';

export default function HeroSec() {
    return(
        <section class="bg-gray-950">
            <div class="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 lg:px-12">
                <a href="#" class="inline-flex justify-between items-center py-1 px-4 pr-4 mb-7 text-sm  rounded-full bg-gray-800 text-white hover:bg-gray-700" role="alert">
                    <span class="text-sm font-medium py-1.5">The Future of Human Resources Management</span> 
                    {/* <svg class="ml-2 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg> */}
                </a>
                <h1 class="mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl lg:text-6xl text-white">Welcome to HR AI Assistant — The Future of Human Resources Management!</h1>
                <p class="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48 text-gray-400">Transform your HR operations with the first-of-its-kind, Free AI HR Assistant, designed to automate and streamline complex HR tasks with just a few words. Our innovative app combines advanced AI technology with user-friendly functionality to empower HR professionals like never before.</p>
                <div class="flex flex-col mb-8 lg:mb-16 space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">
                    
                    <a href="https://play.google.com/store/apps/details?id=com.hrassistancepra&pcampaignid=web_share" class="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center rounded-lg border focus:ring-4 text-white border-gray-700 hover:bg-gray-700 focus:ring-gray-800">
                        {/* <svg class="mr-2 -ml-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"></path></svg> */}
                        Download App
                    </a>  
                </div>
                <div className="images flex flex-row gap-x-5 justify-center">
                    <div className='w-3/12'>
                        <img className='mt-12' src={a2} alt="app image 1" />
                    </div>

                    <div className='w-4/12'>
                        <img src={a1} alt="app image 1" />
                    </div>

                    <div className='w-3/12'>
                        <img className='mt-12' src={a3} alt="app image 1" />
                    </div>
                </div>
            </div>
        </section>
    )
}